import React, {useContext} from "react";
import {getHomepageModel} from "../../../../../selectors/generic";
import {useI18N} from "../../../../my-puratos/hoc/withI18N";
import {ProductContext} from "../../../../pages/ProductStencil";
import {useIsMobile} from "../../../../hoc/hooks";

export const OverlayActions = () => {
    const translate = useI18N();
    const isMobile = useIsMobile();

    const {
        setShowBasketOverlay
    } = useContext(ProductContext);

    return (
        <div className="overlay-content__actions">
            <button className="btn btn-secondary"
                    onClick={() => setShowBasketOverlay(false)}>
                {translate("Continue shopping")}
            </button>
            <button className="btn btn-primary"
                    onClick={() => window.location.href = `${window.location.origin}${getHomepageModel()}/mypuratos/cart`}>
                {isMobile ? translate("Go to shopping cart") : translate("Go to cart")}
            </button>

        </div>
    )
}
